import { disputeSource } from "@redotech/redo-model/disputes/dispute-definition";
import { evidenceColumns } from "@redotech/redo-model/disputes/evidence-config";
import * as z from "zod/v4";

export const generateAllEvidence = {
  name: "generateAllEvidence" as const,
  input: z.object({
    disputeId: z.coerce.bigint(),
    source: z.enum(disputeSource),
    invalidDisputeReason: z.string().optional(),
    perSectionContext: z
      .array(
        z.object({
          column: z.enum(evidenceColumns),
          text: z.string().optional(),
          fileUrls: z.array(z.string()).optional(),
        }),
      )
      .optional(),
  }),
  output: z.object({
    success: z.boolean(),
    errors: z.array(z.string()).optional(),
  }),
};
